module.exports = __webpack_public_path__ + "static/media/complete-funeral-home.a3090400.svg";